// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__3cE7d","tag-check":"styles_tag-check__Y1iUQ","tag-icon":"styles_tag-icon__3lg3t","tag-disable":"styles_tag-disable__1mbuD"};